import PropTypes from 'prop-types';
import React from 'react';
import SalesTypeItemVariantsFields from '../SalesTypeItemVariantsFields';

class SalesTypeItemVariantsContainer extends React.Component {
  render() {
    const { fields, salesType } = this.props;
    const itemVariantFields = [];
    fields.forEach((member, index) => {
      const itemVariantValue = fields.get(index);
      if (itemVariantValue.sales_type_item_variants) {
        itemVariantValue.sales_type_item_variants.forEach(
          (salesTypeItem, salesTypeIvIndex) => {
            if (salesType.id === salesTypeItem.business_level_sales_type_id) {
              itemVariantFields.push(
                <SalesTypeItemVariantsFields
                  member={member}
                  fields={fields}
                  index={index}
                  key={index}
                  salesTypeIndex={salesTypeIvIndex}
                />
              );
            }
          }
        );
      }
    });
    return <div>{itemVariantFields}</div>;
  }
}

SalesTypeItemVariantsFields.propTypes = {
  field: PropTypes.object,
  salesType: PropTypes.object,
};

export default SalesTypeItemVariantsContainer;
